export default __webpack_public_path__ + "static/media/icon6.8405a2fa.svg";